import { Pipe, PipeTransform } from '@angular/core';

import { LicensePlan } from '../models/license-plan';

@Pipe({
	name: 'formatLicensePlans',
	standalone: false,
})
export class FormatLicensePlansPipe implements PipeTransform {
	transform(licensePlans: LicensePlan[]): string {
		return licensePlans
			? licensePlans
					.filter(l => ['Platinum', 'Gold', 'Silver', 'Business Lite'].includes(l.name))
					.map(l => l.name)
					.join(', ')
			: '';
	}
}
